import { connect } from 'react-redux'
import UI from './UI'
import { push } from 'connected-react-router'
import { AddItemToCartAction } from 'components/Cart/store'
import { decorateUrl } from 'components/common/UTMscript'
import { signup } from 'identity/userManager'
import { setOnboardingFreeCourseAction } from 'pages/OnBoardingNext/store'

const mapStateToProps = ({ user, course, currency, referential }) => ({
  ProfileType: referential?.ProfileTypes ? referential?.ProfileTypes[user?.ProfileType] : null,
  Id: course.Course.Id,
  Title: course.Course.Title,
  Image: course.Course.Image,
  MobileImageUrl: course.Course.MobileImageUrl,
  AuthorFirstName: course.Course.Author.FirstName,
  AuthorLastName: course.Course.Author.LastName,
  AuthorPhoto: course.Course.Author.Photo,
  AuthorId: course.Course.AuthorSlug,
  LevelId: course.Course.LevelId,
  Rating: course.Course.Rating,
  ReviewersCount: course.Course.ReviewersCount,
  Price: course.Course.Price,
  Duration: course.Course.Duration,
  ViewersCount: course.Course.ViewersCount,
  Slug: course.Course.Slug,
  IsAccessible: course.Course.IsAccessible,
  AlternativePrice: course.Course.AlternativePrice,
  PricePromo: course.Course.PricePromo,
  AlternativePricePromo: course.Course.AlternativePricePromo,
  IsFree: course.Course.IsFree,
  initialCurrency: currency.initialCurrency
})

const mapDispatchToProps = dispatch => ({
  signup,
  addToCart: course => dispatch(AddItemToCartAction(course)),
  goToTrainer: url => dispatch(push(decorateUrl(url))),
  setOnboardingFreeCourse: state => dispatch(setOnboardingFreeCourseAction(state))
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
